import { tns } from "tiny-slider";

function initTalksCarousel(idCategory) {
  const slider = tns({
    container: ".carousel-container-" + idCategory,
    mode: "carousel",
    controlsContainer: ".controls-" + idCategory,
    controls: true,
    prevButton: ".previous-" + idCategory,
    nextButton: ".next-" + idCategory,
    nav: false,
    loop: true,
    mouseDrag: true,
    gutter: 15,
    items: 1.25,
    responsive: {
      768: {
        items: 3.25,
      }
    },
    onInit: function () {
      const wrapper = document
        .querySelector(".carousel-container-" + idCategory)
        .closest(".carousel-wrapper");
      if (wrapper) {
        wrapper.classList.add("is-inited");
      }
    },
  });

  let isDragging = false;

  slider.events.on('touchStart', () => {
    isDragging = false;
  });

  slider.events.on('touchMove', () => {
    isDragging = true;
  });

  //Intercept clicks on links inside the slider
  const sliderContainer = document.querySelector('.carousel-container-' + idCategory);

  sliderContainer.addEventListener('click', (event) => {
    // Find the closest link element
    const link = event.target.closest('a');
    
    if (link && isDragging) {
      // Stop the link from opening if the user dragged
      event.preventDefault();
    }
  });
}

window.initTalksCarousel = initTalksCarousel;
